import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IRemovePendingCancellationRequest {
	/** The account being taken off the cancel-request list. */
	accountId: string;
	/** Why the cancellation is being reversed. Required by the API and by the legacy flow. */
	reason: string;
}

/**
 * Takes an account off the cancel-request list via `DELETE admin/account/{id}/cancel/remove`. The
 * reason is the request body (a bare string) and the updated account is returned.
 * Mutations have no MutationCache, so the error toast is wired here explicitly.
 */
export function useRemovePendingCancellationMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ accountId, reason }: IRemovePendingCancellationRequest) =>
			userSession.webServiceHelper.callAsync<Api.IAccount>(
				`admin/account/${accountId}/cancel/remove`,
				'DELETE',
				reason
			),
		onError: () => toast.error('Failed to stop the cancellation. Please try again.'),
	});
}
